import { ProColumns } from "@ant-design/pro-table";
import { fileHttpUrl } from "@api/baseUrl";
import { DateRangeWithDisabled } from "@components/Common";
import { Input, Select } from "antd";
import React, { ReactNode } from "react";

const options = [{label: 'options1', value: 1}, {label: 'options2', value: 2}]


const valueEnum = {
    0: { text: '全部', status: 'Default' },
    1: { text: '一致', status: 'Sueecss' },
    2: { text: '不一致', status: 'Error' },
    3: { text: '其他错误', status: 'Processing' },
}


const valueEnumCharge = {
    0: { text: '不收费', status: 'Default' },
    1: { text: '收费', status: 'Sueecss' },
}

/**
 * 列表表格配置:
 *  自定义表格 CustomerDemo 和 antd 升级版组件 ProTableDemo 都可使用, 
 * */
export const columnsFn: (operate: Function) => ProColumns<any>[] = (operate) => {
    return [
        {
            title: 'ID',
            dataIndex: 'serialNumber',
            hideInSearch: true
        },
        {
            title: '企业名称',
            dataIndex: 'entName',
            order: 3,
            // valueType: 'select',
            // hideInSearch: true
        },
        {
            title: '企业资质编号类型',
            dataIndex: 'entQualificationType',
            // key: 'phoneNum',
            hideInSearch: true
        },
        {
            title: '企业资质编号内容',
            dataIndex: 'entQualificationNum',
            // key: 'phoneNum',
            hideInSearch: true
        },
        {
            // title: '企业法定代表人姓名',
            title: (_,type) => type === 'form' ? '法人姓名' : '企业法定代表人姓名',
            dataIndex: 'corporateName',
            order: 2
            // key: 'phoneNum',
            // hideInSearch: true
        },
        {
            // title: '企业法定代表人证件编号',
            title: (_,type) => type === 'form' ? '证件编号' : '企业法定代表人证件编号',
            dataIndex: 'corporateIdCard',
            order: 1
            // key: 'phoneNum',
            // hideInSearch: true
        },
        // {
        //     title: '状态',
        //     dataIndex: 'adCheckTypeStr',
        //     valueType: 'select',
        //     fieldProps: {
        //         defaultValue: '0',
        //         allowClear: false
        //      },
        //     valueEnum: valueEnum,
        //     // valueEnum,
        //     // hideInSearch: true
        // },
        {
            title: '是否计费',
            dataIndex: 'feeStr',
            order: 4,
            valueType: 'select', 
            valueEnum: valueEnumCharge,
            fieldProps: {
                allowClear: false
            },
            formItemProps: {
                // initialValue: '1',  
            },
            search: {
                transform: (value) => {
                    return {fee: value}
                },
            },
        },
        {
            title: '备注',
            dataIndex: 'remark',
            hideInSearch: true
        },
        {
            title: '调用时间',
            dataIndex: 'callTime',
            order: 5,
            // valueType: 'dateTimeRange',
            valueType: 'dateRange',
            fieldProps: { },
            search: {
                transform: (value) => {
                    return {
                        startTime: value[0] ? value[0] + ' 00:00:00' : undefined,
                        endTime: value[1] ? value[1] + ' 23:59:59' : undefined
                    }
                },
            },
            renderFormItem: (props) => <DateRangeWithDisabled />,
            render: (text: any, record: any) => record.callTime,
        }
    ]
}
